module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/9efd02c94f21190f894d213e9a53a2f3.svg";